import { fireanalytics } from '@/store/firebase'

const actions = {
  watch({ commit }, route) {
    route.beforeResolve((to, from, next) => {
      commit('ROUTE_CHANGED', to)
      next()
    })

    route.onReady(() => {
      commit('ROUTE_CHANGED', route.currentRoute)
    })
  },
  isNavCollapsed({ commit }, isNavCollapsed) {
    commit('isNavCollapsed', isNavCollapsed)

    const fromMap = {
      true: 'Open',
      false: 'Closed',
    }
    const toMap = {
      false: 'Open',
      true: 'Closed',
    }

    fireanalytics.event('goal_completion', {
      category: 'Navigation',
      description: 'Toggle Navigation',
      label: `Toggle Navigation from "${fromMap[isNavCollapsed]}" to "${toMap[isNavCollapsed]}"`,
    })
  },
  toggleFullScreen({ commit, state }) {
    const { isLayoutFullScreen } = state
    const newValue = !isLayoutFullScreen
    const analyticsAction = newValue ? 'On' : 'Off'

    commit('isLayoutFullScreen', newValue)

    if (newValue) {
      commit('isNavCollapsed', true)
    }

    fireanalytics.event('goal_completion', {
      category: 'Layout',
      description: 'Full Screen',
      label: `Toggled Full Screen ${analyticsAction}`,
    })
  },
  setDarkMode({ commit, dispatch, rootGetters }, inputDarkMode) {
    const inputValue = typeof inputDarkMode === 'boolean'
    const currentDarkMode = inputValue ? inputDarkMode : !rootGetters['auth/inDarkMode']

    commit('darkMode', currentDarkMode)

    const themes = { dark: currentDarkMode }
    const changes = { themes }

    dispatch('auth/handleUpdateToUserSettings', { changes }, { root: true })

    return currentDarkMode
  },
}

export default actions
